import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var AnnouncementApi = /** @class */ (function () {
    function AnnouncementApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    AnnouncementApi.initialize = function (basePath, fetchApi) {
        if (!AnnouncementApi.instance) {
            AnnouncementApi.instance = new AnnouncementApi(basePath, fetchApi);
        }
        return AnnouncementApi.instance;
    };
    AnnouncementApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1AnnouncementApi(new Configuration(config));
    };
    return AnnouncementApi;
}());
export { AnnouncementApi };
